// extracted by mini-css-extract-plugin
export var acitonButtons = "_h2-0";
export var additionalIcon = "_h2-f";
export var block = "_h2-1";
export var blockContent = "_h2-7";
export var blockDescription = "_h2-8";
export var blockIcon = "_h2-9";
export var blockTitle = "_h2-6";
export var border = "_h2-a";
export var center = "_h2-l";
export var edge = "_h2-b";
export var edgeLabel = "_h2-c";
export var edgePath = "_h2-d";
export var error = "_h2-e";
export var flowchart = "_h2-g";
export var flowchartContent = "_h2-h";
export var highlighted = "_h2-3";
export var hover = "_h2-4";
export var icon = "_h2-i";
export var left = "_h2-m";
export var navButton = "_h2-j";
export var navButtons = "_h2-k";
export var right = "_h2-n";
export var selected = "_h2-2";
export var small = "_h2-5";